import type { HouseholdInsightsApiResponse } from '../apiTypes.ts';
import type { DistributionItem } from '../chartTypes.ts';
import { HOUSEHOLD_CTV_BUCKETS } from '../constants.ts';
import { parseDistribution } from './utils.ts';

export const parseHouseholdCtvs = (response: HouseholdInsightsApiResponse | undefined): DistributionItem[] =>
  parseDistribution(response?.household_ctvs, HOUSEHOLD_CTV_BUCKETS);
